import { eventBus } from "@/eventBus.js";

function copyToClipboard(id) {
  try {
    const el = document.createElement("textarea");
    el.value = document.getElementById(id).innerHTML;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    document.body.removeChild(el);
    eventBus.$toasted.success("Copiado!");
  } catch (e) {
    eventBus.$toasted.error("Ocorreu um erro ao copiar!");
  }
}

export default copyToClipboard;



// WEBPACK FOOTER //
// ./src/utils/functions/copyToClipboard.js